import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    FormControl,
    FormLabel,
    FormHelperText,
    IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const GoalSection = ({ onNext, onBack, isFirstSection, formData }) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: {
            cel_wybor: formData?.cel_wybor,
            zwrot_plec: formData?.zwrot_plec
        }
    });

    // Update form values when formData changes (when user goes back)
    useEffect(() => {
        if (formData?.cel_wybor || formData?.zwrot_plec) {
            reset({
                cel_wybor: formData?.cel_wybor,
                zwrot_plec: formData?.zwrot_plec
            });
        }
    }, [formData, reset]);

    const goalOptions = [
        "Szukam pierwszej pracy",
        "Szukam pracy",
        "Myślę o znalezieniu innej/nowej pracy",
        "Wracam na rynek pracy",
        "Przekwalifikowuję się"
    ];

    const genderOptions = [
        "On",
        "Ona",
        "Neutralnie płciowo _"
    ];

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <Typography variant="h6" color="black">Poświęć tylko 30 minut pracy w skupieniu, by stworzyć swój własny <b>Pakiet Mocy</b> - spersonalizowany plan działania.<br /><br /></Typography>
            <FormControl component="fieldset" error={!!errors.cel_wybor} fullWidth sx={{ mb: 3 }}>
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        W czym mogę Ci dzisiaj pomóc?
                    </Typography>
                </FormLabel>
                <Controller
                    name="cel_wybor"
                    control={control}
                    rules={{ required: "To pole jest wymagane" }}
                    render={({ field }) => (
                        <RadioGroup
                            {...field}
                            aria-label="cel"
                        >
                            {goalOptions.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                />
                            ))}
                        </RadioGroup>
                    )}
                />
                {errors.cel_wybor && (
                    <FormHelperText>{errors.cel_wybor.message}</FormHelperText>
                )}
            </FormControl>

            <FormControl component="fieldset" error={!!errors.zwrot_plec} fullWidth sx={{ mb: 3 }}>
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        Jak się do Ciebie zwracać?
                    </Typography>
                </FormLabel>
                <Controller
                    name="zwrot_plec"
                    control={control}
                    rules={{ required: "To pole jest wymagane" }}
                    render={({ field }) => (
                        <RadioGroup
                            {...field}
                            aria-label="zwrot-plec"
                        >
                            {genderOptions.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                />
                            ))}
                        </RadioGroup>
                    )}
                />
                {errors.zwrot_plec && (
                    <FormHelperText>{errors.zwrot_plec.message}</FormHelperText>
                )}
            </FormControl>

            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <IconButton
                    onClick={onBack}
                    disabled={isFirstSection}
                    sx={{
                        border: '1px solid',
                        borderColor: isFirstSection ? 'action.disabled' : 'primary.main',
                        borderRadius: 1
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    endIcon={<ArrowForwardIcon />}
                >
                    Dalej
                </Button>
            </Box>
        </Box>
    );
};

export default GoalSection; 